import { booleanAttribute, Component, Input, numberAttribute } from "@angular/core";

@Component({
	selector: "button[tgFilterTrigger]",
	templateUrl: "./filter-trigger-button.component.html",
	styleUrls: ["./filter-trigger-button.component.scss"],
	host: {
		class: "mat-button-alt",
		"[class.active]": "active",
	},
})
export class FilterTriggerButtonComponent {
	@Input({ transform: booleanAttribute }) active = false;
	@Input() icon = "";
	/** i18n key for the label; when empty, use labelText. */
	@Input() labelKey = "";
	/** Plain label when not using translate key. */
	@Input() labelText = "";
	@Input({ transform: numberAttribute }) count: number | null = null;
	/** When true, show badge "1" whenever active (e.g. audit filter). */
	@Input({ transform: booleanAttribute }) badgeWhenActive = false;
}
